import { APIFactory } from 'ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from 'ui-toolkit/rest/axiosErrorHandler';
import { baseUrlService } from '../../ui-toolkit/rest/BaseUrlService';

export const removeJournalEntryAsync = async (id: string): Promise<void> =>
  APIFactory(baseUrlService.ApiLocation)
    .delete(`/timber/api/internal/escrow/journal_entries/${id}`)
    // FYI: no content so no response. if it doesn't throw, it worked
    .then(() => void 0)
    .catch(axiosErrorHandler);
